<template>
  <adminTable ref="adminTableRef" :tableLoading="tableLoading" :totalList="totalList" exportLink="GoodLog/export"
    v-model:page="page" v-model:limit="limit" v-model:searchForm="searchForm" v-model:selectedIds="selectedIds"
    :tableData="tableData" @search="getList">
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.username" placeholder="用户名" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.is_test" placeholder="账号类型" clearable>
          <el-option v-for="item in accountTypeEnums" :label="item.label" :value="item.value" :key="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="手机号" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.order_no" placeholder="订单号" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.goods_title" placeholder="商品名称" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" placeholder="状态" clearable>
          <el-option v-for="item in sendStatusEnums" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="购买时间" style="width: 100%" />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="购买时间" style="width: 100%" />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button type="primary" icon="CirclePlus" @click="editItem('add', {})" v-permission>添加</el-button>


    </template>
    <!-- <template #tableInfo>

      <div class="tableInfo">
        <el-button type="success" @click="multipleHandle(1)" v-permission>一键折现</el-button>
        <el-button type="warning" @click="editItem('sendList', {})" v-permission>批量导入订单状态</el-button>
      </div>
    </template> -->
    <template v-slot:table>
      <el-table-column type="selection" :selectable="(row) => row.status == 1" width="55" />
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="username" label="用户名" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.username }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号码" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="用户类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="goods_title" label="商品名称" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.goods_title }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="order_no" label="订单号" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.order_no }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.desc }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="200">
        <template #default="scope">
          <span :class="{ green: scope.row.status == 1 }">{{
            getLabelByVal(scope.row.status, sendStatusEnums)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.remark }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="兑换时间" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.create_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" :resizable="false" width="240px" v-if="currentUser.role == 0">
        <template #default="scope">
          <div class="table-handle-td">
            <el-button type="primary" icon="Edit" v-permission @click="editItem('edit', scope.row)">操作</el-button>
          </div>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" :title="formType === 'sendList' ? '批量编辑' : '新增/编辑'"
      :width="formType === 'sendList' ? 700 : 1100">
      <editPop v-if="formType === 'add' || formType === 'edit'" :key="editRow" :formType="formType" ref="editFormRef"
        :item="editRow" />
      <SendListPop v-if="formType === 'sendList'" :key="editRow" ref="sendListFormRef" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import {
  booleanEnums,
  getLabelByVal,
  changeMoneyEnums,
  accountTypeEnums,
  handlersBooleanEnums,
  sendStatusEnums,
} from "@/config/enums";
import EditPop from "./components/goodsRecords/editPop.vue";
import SendListPop from "./components/goodsRecords/sendListPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  username: "",
  phone: "",
  order_no: "",
  goods_title: "",
  status: "",
  starttime: "",
  endtime: "",
  is_test: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const sendListFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

onMounted(() => {
  getList();
});

const selectedIds = ref([]);
const multipleHandle = (type, ids = []) => {
  if (ids.length > 0) {
    selectedIds.value = ids;
  }
  if (selectedIds.value == 0) {
    ElMessage({
      type: "error",
      message: "请选择需要操作的列表",
    });
    return;
  }
  ElMessageBox.prompt(`请输入批量折现理由`, "提示", {
    confirmButtonText: "提交",
    cancelButtonText: "取消",
  })
    .then(async ({ value }) => {
      const res = await proxy.$http({
        method: "post",
        url: "/GoodLog/cashBack",
        data: {
          ids: selectedIds.value,
          status: type,
          remark: value,
        },
      });
      if (res.code == 0) {
        ElMessage({
          type: "success",
          message: `批量折现成功，折现理由是${value}`,
        });
        getList();
      } else {
        ElMessage({
          type: "error",
          message: res.msg,
        });
      }
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消操作！",
      });
    });
};

const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  if (formType.value === 'sendList') {
    const data = sendListFormRef.value.form;
    if (!data.text) {
      ElMessage({
        type: "error",
        message: '没有可提交的数据',
      });
      return
    }
    const ret = await proxy.$http({
      method: 'post',
      url: '/GoodLog/batchUpdateGoodLog',
      data: {
        text: data.text
      }
    })
    if (ret.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: ret.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: ret.msg,
      });
    }

    return
  } else {
    const url =
      formType.value == "add" ? "GoodLog/addGoodLog" : "GoodLog/updateGoodLog";
    const data = editFormRef.value.form;
    if (formType.value == "add") {
      data.id = null;
    }
    const res = await proxy.$http({
      method: "post",
      url: url,
      data: {
        username: data.username,
        phone: data.phone,
        deliver_order_no: data.deliver_order_no,
        deliver_title: data.deliver_title,
        address_name: data.address_name,
        address_phone: data.address_phone,
        address_city: data.address_city,
        address_place: data.address_place,
        status: data.status,
        deliver_title: data.deliver_title,
        deliver_order_no: data.deliver_order_no,
        deliver_time: data.deliver_time,
        goods_id: data.goods_id,
        id: data.id,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  }

};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "GoodLog/deleteGoodLog?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/GoodLog/getGoodLogLists",
    params: {
      page: page.value,
      limit: limit.value,
      is_exchange:1,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped>
.table-handle-td {
  display: flex;
  cursor: pointer;
  flex-wrap: wrap;

  button {
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 10px;
  }
}

.tableInfo {
  padding: 10px 0;
  display: flex;
  justify-content: flex-start;
}
</style>
